import useGoogleAnalytics from './WithGoogleAnalytics';
export default useGoogleAnalytics;
